import is from "@sindresorhus/is";

const MAX_CATEGORIES = 100;

const wpGetCategories = axios =>
  new Promise((resolve, reject) =>
    Promise.resolve()
      .then(() => axios.get(`categories?per_page=${MAX_CATEGORIES}`))
      .then(axiosResponse => (is.array(axiosResponse.data) ? resolve(axiosResponse.data) : reject(new Error("Invalid WP response, while getting categories."))))
      .catch(error => reject(error))
  );

export default wpGetCategories;
